<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div class="manage-pre-register-page">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          {{ $t("message.ManagePreRegister") }}
        </div>
        <v-row class="project-site-row" justify="end">
          <v-col cols="12" sm="6" md="4" lg="3" class="project-site-col">
            <v-autocomplete
              v-model="ProjectSite"
              :items="ProjectSiteList"
              hide-details
              hide-selected
              clearable
              :label="$t('message.ProjectSite')"
              item-text="projectName"
              item-value="projectID"
              outlined
              dense
              @change="getDataTransactionPreRegister()"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-card-text>
          <div>
            <v-card elevation="10" class="pre-register-filter-card">
              <v-row align="center">
                <v-col cols="12" sm="6" md="2" lg="2">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="startDate"
                        :label="$t('message.StartDate')"
                        append-icon="mdi-calendar-month"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        outlined
                        hide-details="auto"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      @change="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="2">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="endDate"
                        :label="$t('message.EndDate')"
                        append-icon="mdi-calendar-month"
                        outlined
                        hide-details="auto"
                        dense
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      @change="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="4"
                  class="pre-register-search-col"
                  style="margin-top: 25px"
                >
                  <v-text-field
                    :label="$t('message.Search')"
                    append-icon="mdi-database-search-outline"
                    @keyup.enter="getDataTransactionPreRegister"
                    v-model="search"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="4"
                  class="pre-register-filter-actions"
                >
                  <v-btn
                    :color="'blue'"
                    class="ma-2 white--text"
                    @click="getDataTransactionPreRegister()"
                  >
                    {{ $t("message.Search") }}
                    <v-icon right>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                    color="green"
                    class="ma-2 white--text"
                    @click="openExportDialog"
                  >
                    {{ $t("message.ExportExcel") }}
                    <v-icon right>mdi-file-excel-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <div class="table-responsive">
                    <v-data-table
                      :headers="headers"
                      :items="ListData"
                      hide-default-footer
                      class="pos-data-table"
                      :items-per-page="itemsPerPage"
                      :page.sync="page"
                      single-line
                      hide-details
                    >
                      <template v-slot:item="{ item, index }">
                        <tr class="d-none d-sm-table-row">
                          <td class="header-table-css">
                            {{ no_run + (index + 1) }}
                          </td>
                          <td class="header-table-css">
                            {{ item.visitorName }}
                          </td>
                          <td class="header-table-css">
                            {{ item.visitorLasName }}
                          </td>
                          <td class="header-table-css">
                            {{ item.licensePlate }}
                          </td>
                          <td class="header-table-css">
                            {{ ConvertNameVisitorType(item.visitorType) }}
                          </td>
                          <td class="header-table-css">
                            {{ GetProjectSiteName(item.projectID) }}
                          </td>
                          <td class="header-table-css">
                            {{ ChangeFormatDate(item.createTime) }}
                          </td>
                          <td class="header-table-css">{{ item.subject }}</td>
                          <td style="text-align: center">
                            <img
                              v-if="item.visitorType == 1"
                              :src="
                                item.approve == true
                                  ? require('@/assets/correct.png')
                                  : require('@/assets/close.png')
                              "
                              width="20"
                              height="20"
                            />
                            <span v-else>-</span>
                          </td>
                          <td style="text-align: center">
                            <v-btn
                              :color="GetColor(item.status)"
                              rounded
                              depressed
                              style="width: 100px"
                            >
                              <span
                                :style="{ color: GetColorText(item.status) }"
                                >{{ ConvertNameStatus(item.status) }}</span
                              >
                            </v-btn>
                          </td>
                          <td style="text-align: center">
                            <v-btn
                              v-if="item.visitorType == 'Pre Register'"
                              :disabled="
                                !item.active || item.status == 'Expired'
                              "
                              class="mx-1"
                              fab
                              small
                              dark
                              color="#2196F3"
                              @click="ShowQRPreRegister(item.visitorID)"
                            >
                              <v-icon dark>mdi-qrcode</v-icon>
                            </v-btn>
                            <v-btn
                              v-else
                              :disabled="
                                !item.active || item.status == 'Expired'
                              "
                              class="mx-1 black--text"
                              fab
                              small
                              dark
                              color="white"
                              @click="ReprintQRCode(item.visitorID)"
                            >
                              <v-icon dark>mdi-qrcode</v-icon>
                            </v-btn>
                            <v-btn
                              class="mx-1"
                              fab
                              small
                              dark
                              color="orange"
                              @click="ViewDataPreRegisterDialog(item.visitorID)"
                            >
                              <v-icon dark>mdi-eye</v-icon>
                            </v-btn>
                            <v-btn
                              :disabled="
                                !item.active || item.status == 'Expired'
                              "
                              class="mx-1"
                              fab
                              small
                              dark
                              color="red"
                              @click="cancelPreRegisterByUid(item)"
                            >
                              <v-icon dark>mdi-cancel</v-icon>
                            </v-btn>
                          </td>
                        </tr>

                        <tr class="d-sm-none">
                          <td colspan="100%">
                            <v-card flat class="pa-3 my-2">
                              <div style="font-size: 22px">
                                {{ no_run + (index + 1) }}.
                                {{ item.visitorName }} {{ item.visitorLasName }}
                              </div>
                              <div style="font-size: 18px">
                                <strong>ทะเบียน:</strong>
                                {{ item.licensePlate }} |
                                <strong>ประเภท:</strong>
                                {{ ConvertNameVisitorType(item.visitorType) }}
                              </div>
                              <div style="font-size: 18px">
                                <strong>วันที่:</strong>
                                {{ ChangeFormatDate(item.createTime) }}
                              </div>
                              <div class="mt-1" style="font-size: 18px">
                                <strong>สถานะ:</strong>
                                <v-chip
                                  :color="GetColor(item.status)"
                                  :text-color="GetColorText(item.status)"
                                  small
                                  class="ml-2"
                                  >{{ ConvertNameStatus(item.status) }}</v-chip
                                >
                              </div>
                              <div class="d-flex justify-end mt-2">
                                <v-btn
                                  v-if="item.visitorType == 'Pre Register'"
                                  :disabled="
                                    !item.active || item.status == 'Expired'
                                  "
                                  small
                                  fab
                                  color="#2196F3"
                                  class="mx-1"
                                  @click="ShowQRPreRegister(item.visitorID)"
                                >
                                  <v-icon small>mdi-qrcode</v-icon>
                                </v-btn>
                                <v-btn
                                  v-else
                                  :disabled="
                                    !item.active || item.status == 'Expired'
                                  "
                                  small
                                  fab
                                  color="white"
                                  class="mx-1 black--text"
                                  @click="ReprintQRCode(item.visitorID)"
                                >
                                  <v-icon small>mdi-qrcode</v-icon>
                                </v-btn>
                                <v-btn
                                  small
                                  fab
                                  color="orange"
                                  class="mx-1"
                                  @click="
                                    ViewDataPreRegisterDialog(item.visitorID)
                                  "
                                >
                                  <v-icon small>mdi-eye</v-icon>
                                </v-btn>
                                <v-btn
                                  small
                                  fab
                                  color="red"
                                  class="mx-1"
                                  :disabled="
                                    !item.active || item.status == 'Expired'
                                  "
                                  @click="cancelPreRegisterByUid(item)"
                                >
                                  <v-icon small>mdi-cancel</v-icon>
                                </v-btn>
                              </div>
                            </v-card>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-5 pre-register-pagination-row" align="center">
                <v-col
                  cols="12"
                  md="8"
                  lg="9"
                  class="pre-register-pagination-col"
                >
                  <v-pagination
                    v-model="page"
                    :total-visible="paginationTotalVisible"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  class="pre-register-page-size-col"
                >
                  <v-autocomplete
                    class="pre-register-page-size"
                    dense
                    solo
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    label="10/page"
                    :items="items"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog
      v-model="PreRegisterDataDialog"
      persistent
      max-width="800px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="rounded-xl elevation-4 pre-register-detail-card">
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h6 font-weight-bold">
            {{ $t("message.PreRegisterDetail") }}
          </span>
          <v-btn icon variant="text" @click="PreRegisterDataDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pre-register-detail-content">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.FirstName')"
                v-model="VisitorName"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.LastName')"
                v-model="VisitorLastName"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.Email')"
                v-model="Email"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.PhoneNumber')"
                v-model="PhoneNumber"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.LicensePlate')"
                v-model="LicensePlate"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.Province')"
                v-model="Province"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.StartDate')"
                v-model="Start_Date"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.EndDate')"
                v-model="End_Date"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.CreateTime')"
                v-model="CreateTime"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.Subject')"
                v-model="Subject"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.ProjectSite')"
                v-model="ProjectSiteView"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-row
                style="
                  display: flex;
                  justify-content: space-between;
                  padding-left: 20px;
                  padding-bottom: 20px;
                "
                v-if="VisitorType == 1"
              >
                <v-switch
                  v-model="approve"
                  inset
                  hide-details
                  disabled
                  :label="
                    approve ? $t('message.Approved') : $t('message.NotApproved')
                  "
                />
                <v-switch
                  v-model="active"
                  inset
                  hide-details
                  disabled
                  :label="
                    active ? $t('message.Active') : $t('message.InActive')
                  "
                />
              </v-row>
              <v-row
                style="
                  display: flex;
                  justify-content: left;
                  padding-left: 20px;
                  padding-bottom: 20px;
                "
                v-else
              >
                <v-switch
                  v-model="active"
                  inset
                  hide-details
                  disabled
                  :label="
                    active ? $t('message.Active') : $t('message.InActive')
                  "
                />
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="ShowImageDialog"
      persistent
      max-width="900px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="pa-6 rounded-xl qr-dialog-card">
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6" class="d-flex justify-center">
              <div id="PrintWrapper" class="qr-print-wrapper">
                <v-card
                  id="QRCode"
                  elevation="6"
                  class="rounded-xl pb-16 pos-font-fix qr-code-card"
                >
                  <div class="d-flex justify-center">
                    <v-img
                      alt="Logo"
                      class="shrink app"
                      contain
                      src="@/assets/logo_chememan.svg"
                      transition="scale-transition"
                      width="300"
                    />
                  </div>

                  <div class="d-flex justify-center mt-10">
                    <qrcode-vue :value="QRvalue" :size="QRsize" level="M" />
                  </div>

                  <v-row class="text-body-1 font-weight-bold mt-4 justify-center">
                    <span>{{ QRProjectName }}</span>
                  </v-row>
                  <v-row class="text-body-1 font-weight-bold mt-3 justify-center">
                    <span>{{ QRVisitorName }} {{ QRVisitorLastName }}</span>
                  </v-row>

                  <v-row
                    class="mt-5 text-body-1 font-weight-medium justify-center"
                  >
                    <span>{{ QRLicensePlate }} {{ QRProvince }}</span>
                  </v-row>

                  <v-row
                    class="mt-4 text-body-1 font-weight-medium justify-center"
                  >
                    <span>{{ QRVehicleType }}</span>
                  </v-row>

                  <v-row
                    class="mt-6 text-body-1 font-weight-medium justify-center"
                  >
                    <span>
                      StartDate:
                      {{
                        ChangeFormatDateQR(QRDate) +
                        " " +
                        ChangeFormatTimeQR(QRTime)
                      }}
                    </span>
                  </v-row>

                  <v-row
                    class="mt-4 text-body-1 font-weight-medium justify-center"
                  >
                    <span style="white-space: nowrap; text-align: center">
                      ExpireDate:
                      {{
                        ChangeFormatDateQR(QRExpireDate) +
                        " " +
                        ChangeFormatTimeQR(QRExpireTime)
                      }}
                    </span>
                  </v-row>
                  <v-row
                    class="mt-4 text-body-1 font-weight-medium justify-center"
                  >
                    <span>{{ QRSubject }}</span>
                  </v-row>

                  <v-row class="justify-center">
                    <span
                      style="
                        width: 300px;
                        border: 1px solid black;
                        display: inline-block;
                        margin-top: 100px;
                        margin-bottom: 10px;
                      "
                    ></span>
                  </v-row>

                  <v-row class="text-body-1 font-weight-medium justify-center">
                    <span>ผู้รับการติดต่อ</span>
                  </v-row>

                  <v-row class="text-body-1 font-weight-medium justify-center">
                    <span
                      style="
                        font-size: 12px;
                        margin-top: 40px;
                        white-space: nowrap;
                      "
                      >กรุณาเก็บ QRCode นี้ไว้สแกนขาออก</span
                    >
                  </v-row>

                  <v-card elevation="0">
                    <p style="margin-top: 30px">
                      <span style="color: grey">.</span>
                    </p>
                  </v-card>
                </v-card>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="d-flex flex-column align-center justify-center"
            >
              <v-btn
                color="success"
                class="ma-4 pa-6 rounded-xl d-flex"
                style="width: 160px; height: 160px"
                @click="PrintQRParking()"
              >
                <v-icon size="28">mdi-printer</v-icon>
                <div class="text-subtitle-1 font-weight-medium">Re Print</div>
              </v-btn>

              <v-btn
                color="grey darken-1"
                class="ma-4 pa-6 rounded-xl d-flex"
                style="width: 160px; height: 160px"
                @click="ClosePrintQRDialog()"
              >
                <v-icon size="28">mdi-close-circle-outline</v-icon>
                <div class="text-subtitle-1 font-weight-medium">Close</div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="ExportDialog"
      persistent
      max-width="620px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="export-dialog-card">
        <div class="export-dialog-header">
          <div class="export-dialog-icon">
            <v-icon color="white" size="30">mdi-file-excel-outline</v-icon>
          </div>
          <div>
            <div class="text-h6 font-weight-bold">
              {{ $t("message.ExportExcel") }}
            </div>
          </div>
        </div>
        <v-card-text class="export-dialog-content">
          <v-row class="mt-1">
            <v-col cols="12">
              <v-autocomplete
                v-model="exportProjectSite"
                :items="ProjectSiteList"
                :label="$t('message.ProjectSite')"
                item-text="projectName"
                item-value="projectID"
                outlined
                dense
                clearable
                hide-details="auto"
                prepend-inner-icon="mdi-map-marker"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu
                v-model="exportStartDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="exportStartDate"
                    :label="$t('message.StartDate')"
                    append-icon="mdi-calendar-month"
                    readonly
                    outlined
                    dense
                    clearable
                    :error="exportDateRangeInvalid"
                    hide-details="auto"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="exportStartDate"
                  :max="exportEndDate || undefined"
                  @change="exportStartDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu
                v-model="exportEndDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="exportEndDate"
                    :label="$t('message.EndDate')"
                    append-icon="mdi-calendar-month"
                    readonly
                    outlined
                    dense
                    clearable
                    :error-messages="exportDateError"
                    hide-details="auto"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="exportEndDate"
                  :min="exportStartDate || undefined"
                  @change="exportEndDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <div class="export-dialog-note">
            <v-icon small color="blue-grey" class="mr-2">
              mdi-information-outline
            </v-icon>
            {{ $t("message.ExportDetail") }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="export-dialog-actions">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-2"
            :disabled="ExportLoading"
            @click="ExportDialog = false"
          >
            {{ $t("message.Cancel") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            class="white--text px-5"
            depressed
            :loading="ExportLoading"
            :disabled="!exportCanSubmit"
            @click="exportExcel"
          >
            {{ $t("message.ExportExcel") }}
            <v-icon right>mdi-file-excel-outline</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import QrcodeVue from "qrcode.vue";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx-js-style";
export default {
  name: "ManagePreRegisterParking",
  components: {
    QrcodeVue,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      no_run: 0,

      startDate: "",
      endDate: "",
      menu1: false,
      menu2: false,
      ExportDialog: false,
      ExportLoading: false,
      exportStartDate: "",
      exportEndDate: "",
      exportProjectSite: null,
      exportStartDateMenu: false,
      exportEndDateMenu: false,

      ListData: [],
      PreRegisterDataDialog: false,
      VisitorName: "",
      VisitorLastName: "",
      Email: "",
      PhoneNumber: "",
      Start_Date: "",
      End_Date: "",
      CreateTime: "",
      LicensePlate: "",
      Province: "",
      approve: false,
      active: false,
      ShowImageDialog: false,
      QRvalue: "",
      QRsize: 120,
      VisitorType: null,
      Subject: "",

      QRLicensePlate: "",
      QRProvince: "",
      QRDate: "",
      QRTime: "",
      QRExpireDate: "",
      QRExpireTime: "",
      QRVisitorName: "",
      QRVisitorLastName: "",
      Base64: "",
      QRVehicleType: "",
      QRSubject: "",
      QRProjectName: "",
      ProjectSite: null,
      ProjectSiteList: [],
      ProjectSiteView: "",
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: this.$t("message.FirstName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.LastName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.LicensePlate"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.VisitorType"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.ProjectSite"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.CreateTime"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Subject"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.StatusApprove"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Status"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          sortable: false,
        },
      ];
    },
    paginationTotalVisible() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 5;
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        return 7;
      }

      return 10;
    },
    exportDateRangeInvalid() {
      return Boolean(
        this.exportStartDate &&
          this.exportEndDate &&
          this.exportEndDate < this.exportStartDate
      );
    },
    exportDateError() {
      return this.exportDateRangeInvalid
        ? ["End date must not be earlier than start date."]
        : [];
    },
    exportCanSubmit() {
      return Boolean(
        this.exportStartDate &&
          this.exportEndDate &&
          !this.exportDateRangeInvalid
      );
    },
  },

  async mounted() {
    let self = this;
    self.getDataTransactionPreRegister();
    self.getDataDropdownProjectSite();
  },

  methods: {
    GetProjectSiteName(projectID) {
      const projectSite = this.ProjectSiteList.find(
        (item) => item.projectID == projectID
      );
      return projectSite ? projectSite.projectName : "-";
    },

    openExportDialog() {
      this.exportStartDate = this.startDate || "";
      this.exportEndDate = this.endDate || "";
      this.exportProjectSite = this.ProjectSite;
      this.ExportDialog = true;
    },

    async exportExcel() {
      if (!this.exportStartDate || !this.exportEndDate) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please select a start date and end date.",
        });
        return;
      }

      if (this.exportDateRangeInvalid) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "End date must not be earlier than start date.",
        });
        return;
      }

      this.ExportLoading = true;
      try {
        const response = await axios.post(
          `${this.url}PreRegister/exportDataTransactionPreRegisterParking`,
          {
            startDate: this.exportStartDate,
            endDate: this.exportEndDate,
            projectID: this.exportProjectSite,
          }
        );

        if (response.data.status != 0) {
          throw new Error(response.data.message || "Unable to export data.");
        }

        const data = response.data.data || [];
        if (data.length === 0) {
          Swal.fire({
            icon: "info",
            title: "No data",
            text: "No pre-register parking data was found in the selected date range.",
          });
          return;
        }

        const headers = [
          this.$t("message.No"),
          this.$t("message.FirstName"),
          this.$t("message.LastName"),
          this.$t("message.LicensePlate"),
          this.$t("message.VisitorType"),
          this.$t("message.ProjectSite"),
          this.$t("message.CreateTime"),
          this.$t("message.Subject"),
          this.$t("message.StatusApprove"),
          this.$t("message.Status"),
        ];
        const rows = data.map((item, index) => [
          index + 1,
          item.visitorName || "",
          item.visitorLasName || "",
          item.licensePlate || "",
          this.ConvertNameVisitorType(item.visitorType),
          item.projectName || "-",
          this.ChangeFormatDate(item.createTime),
          item.subject || "",
          item.approve
            ? this.$t("message.Approved")
            : this.$t("message.NotApproved"),
          this.ConvertNameStatus(item.status),
        ]);

        const worksheet = XLSX.utils.aoa_to_sheet([
          ["Transaction Pre Register"],
          [
            `Filter Date: ${this.formatExportDate(
              this.exportStartDate
            )} - ${this.formatExportDate(this.exportEndDate)}`,
          ],
          [
            `Project Site: ${this.GetProjectSiteName(this.exportProjectSite)}`,
          ],
          [],
          headers,
          ...rows,
        ]);
        worksheet["!merges"] = [
          {
            s: { r: 0, c: 0 },
            e: { r: 0, c: headers.length - 1 },
          },
        ];
        worksheet["A1"].s = {
          font: {
            bold: true,
            color: { rgb: "333333" },
            sz: 16,
          },
          fill: {
            patternType: "solid",
            fgColor: { rgb: "BFBFBF" },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
        worksheet["A2"].s = {
          font: {
            italic: true,
            color: { rgb: "555555" },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
        worksheet["!merges"].push({
          s: { r: 1, c: 0 },
          e: { r: 1, c: headers.length - 1 },
        });
        worksheet["!rows"] = [
          { hpt: 26 },
          { hpt: 20 },
          { hpt: 20 },
          { hpt: 8 },
          { hpt: 22 },
        ];

        headers.forEach((header, index) => {
          const cellAddress = XLSX.utils.encode_cell({ r: 4, c: index });
          worksheet[cellAddress].s = {
            font: {
              bold: true,
              color: { rgb: "333333" },
            },
            fill: {
              patternType: "solid",
              fgColor: { rgb: "BDD7EE" },
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
            },
            border: {
              top: { style: "thin", color: { rgb: "B7B7B7" } },
              bottom: { style: "thin", color: { rgb: "B7B7B7" } },
              left: { style: "thin", color: { rgb: "B7B7B7" } },
              right: { style: "thin", color: { rgb: "B7B7B7" } },
            },
          };
        });
        worksheet["!cols"] = [
          { wch: 8 },
          { wch: 20 },
          { wch: 20 },
          { wch: 18 },
          { wch: 20 },
          { wch: 24 },
          { wch: 22 },
          { wch: 30 },
          { wch: 18 },
          { wch: 15 },
        ];
        worksheet["!autofilter"] = {
          ref: `A5:${XLSX.utils.encode_col(headers.length - 1)}${
            rows.length + 5
          }`,
        };

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "PreRegisterParking");
        XLSX.writeFile(
          workbook,
          `PreRegisterParking_${this.exportStartDate}_${this.exportEndDate}.xlsx`
        );
        this.ExportDialog = false;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error...",
          width: 900,
          text:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error,
        });
      } finally {
        this.ExportLoading = false;
      }
    },

    formatExportDate(date) {
      if (!date) return "";
      const dateParts = date.split("-");
      return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
    },

    getDataDropdownProjectSite() {
      let self = this;
      axios
        .get(`${self.url}Management/getDataDropdownProjectSite`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ProjectSiteList = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        });
    },

    getDataTransactionPreRegister() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        startDate: self.startDate,
        endDate: self.endDate,
        projectID: self.ProjectSite,
      };
      axios
        .post(
          `${self.url}PreRegister/getDataTransactionPreRegisterParking`,
          temp
        )
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        startDate: self.startDate,
        endDate: self.endDate,
        projectID: self.ProjectSite,
      };
      axios
        .post(
          `${self.url}PreRegister/getDataTransactionPreRegisterParking`,
          temp
        )
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perPage: value,
        startDate: self.startDate,
        endDate: self.endDate,
        projectID: self.ProjectSite,
      };
      axios
        .post(
          `${self.url}PreRegister/getDataTransactionPreRegisterParking`,
          temp
        )
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        });
    },

    ViewDataPreRegisterDialog(data) {
      let self = this;
      self.ViewDataPreRegister(data);
    },

    ViewDataPreRegister(data) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        visitorID: data,
      };
      axios
        .post(
          `${self.url}PreRegister/getDataTransactionPreRegisterParkingByUid`,
          temp
        )
        .then(function (response) {
          if (response.data.status == 0) {
            self.BindingDataPreRegister(response.data.data);
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        });
    },

    BindingDataPreRegister(data) {
      let self = this;
      self.VisitorName = data.visitorName;
      self.VisitorLastName = data.visitorLastname;
      self.Email = data.email;
      self.PhoneNumber = data.phoneNumber;
      self.LicensePlate = data.licensePlate;
      self.Province = data.province;
      self.Start_Date = self.ChangeFormatDate(data.startDate);
      self.End_Date = self.ChangeFormatDate(data.expireDate);
      self.CreateTime = self.ChangeFormatDate(data.createTime);
      self.Subject = data.subject;
      self.approve = data.approve;
      self.VisitorType = data.visitorType;
      self.ProjectSiteView = data.projectSite;
      self.active = data.active;
      self.PreRegisterDataDialog = true;
    },

    cancelPreRegisterByUid(data) {
      let self = this;
      let temp = {
        visitorID: data.visitorID,
        visitorType: data.visitorType == "Pre Register" ? 1 : 2,
      };
      Swal.fire({
        text: "คุณต้องการ Reject ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          self.LoadingDialog = true;
          axios
            .post(`${self.url}PreRegister/rejectPreRegisterByVisitorID`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.getDataTransactionPreRegister();
              }
            })
            .catch(function (error) {
              self.LoadingDialog = false;
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 900,
                text: error.response.data.message,
              });
            })
            .finally(function () {
              self.LoadingDialog = false;
            });
        }
      });
    },

    ReprintQRCode(uid) {
      let self = this;
      if (uid != "") {
        self.LoadingDialog = true;
        let temp = {
          visitorID: uid,
        };
        axios
          .post(
            `${self.url}PreRegister/getDataTransactionEntryParkingByUid`,
            temp
          )
          .then(function (response) {
            if (response.data.status == 0) {
              self.LoadingDialog = false;
              self.QRLicensePlate = response.data.data.licensePlate;
              self.QRProvince = response.data.data.province;
              self.QRDate = response.data.data.startDate;
              self.QRTime = response.data.data.startDate;
              self.QRVisitorName = response.data.data.visitorName;
              self.QRVisitorLastName = response.data.data.visitorLastname;
              self.QRExpireDate = response.data.data.expireDate;
              self.QRExpireTime = response.data.data.expireDate;
              self.QRVehicleType = response.data.data.vehicleType;
              self.QRSubject = response.data.data.subject;
              self.QRProjectName = response.data.data.projectName;
              self.QRvalue =
                "https://smartgate-carpark-api.chememan.com/" + uid;
              self.ShowImageDialog = true;
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            self.LoadingDialog = false;
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          });
      }
    },

    PrintQRParking() {
      const el = document.querySelector("#PrintWrapper");
      html2canvas(el, { backgroundColor: "#ffffff", scale: 2 }).then(
        (canvas) => {
          const base64 = canvas.toDataURL("image/png");

          if (
            typeof window.Android !== "undefined" &&
            window.Android.printBase64Image
          ) {
            window.Android.printBase64Image(base64);
          } else {
            var tWindow = window.open("", "_blank");
            tWindow.document.write(
              "<html><head><title>Print</title></head><body style='margin:0;padding:0;text-align:center;background:white;'>"
            );
            tWindow.document.body.appendChild(canvas);
            tWindow.document.write("</body></html>");
            tWindow.document.close();
            tWindow.focus();
            setTimeout(() => {
              tWindow.print();
              tWindow.close();
            }, 500);
          }

          this.Base64 = base64;
        }
      );
    },

    ClosePrintQRDialog() {
      let self = this;
      self.ShowImageDialog = false;
    },

    ShowQRPreRegister(data) {
      window.open("QRPreRegisterParking/" + data, "_blank");
    },

    GetColor(value) {
      if (value == "Active") {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == "Active") {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    ConvertNameVisitorType(Name) {
      if (Name != 0) {
        if (Name == 1) {
          return this.$t("message.PreRegisterParking");
        } else if (Name == 2) {
          return this.$t("message.WalkInName");
        } else if (Name == 3) {
          return this.$t("message.JorporPlus");
        } else if (Name == 4) {
          return this.$t("message.SelfPreRegister");
        }
      }
      return "";
    },

    ConvertNameStatus(Name) {
      if (Name != "") {
        if (Name == "Active") {
          return this.$t("message.Active");
        } else if (Name == "Expired") {
          return this.$t("message.Expired");
        } else {
          return this.$t("message.Rejected");
        }
      }
      return "";
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    ChangeFormatDateQR(date) {
      if (!date) return null;
      const DateData = new Date(date);

      const day = DateData.getDate().toString().padStart(2, "0");
      const month = (DateData.getMonth() + 1).toString().padStart(2, "0");
      const year = DateData.getFullYear();

      return `${day}/${month}/${year}`;
    },

    ChangeFormatTimeQR(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      //var seconds = DateData.getSeconds();
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      //seconds = seconds < 10 ? "0" + seconds : seconds;
      var strTime = hours + ":" + minutes;
      return strTime;
    },
  },
};
</script>
  <style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

.export-dialog-card {
  overflow: hidden;
  border-radius: 14px;
}

.export-dialog-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 28px;
  background-color: #f3faf5;
  color: #263238;
}

.export-dialog-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 54px;
  width: 54px;
  height: 54px;
  border-radius: 12px;
  background-color: #2e7d32;
}

.export-dialog-content {
  padding: 26px 28px 22px;
}

.export-dialog-note {
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding: 12px 14px;
  border-radius: 8px;
  background-color: #f5f7f8;
  color: #546e7a;
  font-size: 13px;
}

.export-dialog-actions {
  padding: 16px 28px 20px;
}

.manage-pre-register-page {
  margin-left: 10px;
  margin-right: 10px;
}

.project-site-row {
  padding-right: 1%;
}

.project-site-col {
  text-align: center;
}

.pre-register-filter-card {
  padding: 2%;
  margin-top: 2%;
  margin-bottom: 2%;
}

.pre-register-search-col {
  flex-grow: 1;
}

.pre-register-filter-actions {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding-top: 20px;
}

.pre-register-filter-actions .v-btn {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.pos-data-table {
  min-width: 1320px;
}

.pre-register-pagination-col {
  display: flex;
  justify-content: center;
}

.pre-register-page-size-col {
  display: flex;
  justify-content: flex-end;
}

.pre-register-page-size {
  max-width: 180px;
}

.pre-register-detail-card,
.qr-dialog-card {
  overflow: hidden;
}

.pre-register-detail-content {
  padding: 24px;
}

.qr-print-wrapper {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
}

.qr-code-card {
  width: 380px;
  min-height: 450px;
  background-color: #fff;
  padding: 55px;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

@media (max-width: 768px) {
  .manage-pre-register-page {
    margin-left: 0;
    margin-right: 0;
  }

  .project-site-row {
    padding-right: 0;
  }

  .pre-register-filter-card {
    padding: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .pre-register-filter-actions {
    justify-content: flex-start;
    padding-top: 0 !important;
  }

  .pre-register-filter-actions .v-btn {
    min-width: 0;
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .pos-data-table {
    min-width: 0;
  }

  .pre-register-page-size-col {
    justify-content: center;
  }

  .pre-register-page-size {
    max-width: 220px;
  }

  .pre-register-detail-card,
  .qr-dialog-card,
  .export-dialog-card {
    border-radius: 0 !important;
  }

  .pre-register-detail-content,
  .export-dialog-content {
    padding: 16px !important;
  }

  .export-dialog-header {
    padding: 20px 16px;
  }

  .export-dialog-actions {
    display: block;
    padding: 16px;
  }

  .export-dialog-actions .v-btn {
    width: 100%;
    margin-top: 8px;
  }

  .qr-dialog-card {
    padding: 12px !important;
  }

  .qr-print-wrapper {
    width: 100%;
    padding: 8px;
    overflow-x: auto;
  }

  .qr-code-card {
    width: 320px;
    min-height: 430px;
    padding: 32px !important;
  }

  .header-table-css {
    font-size: 12px;
    padding: 4px !important;
  }
}

@media (max-width: 768px) {
  .pos-font-fix span {
    font-size: 12px !important;
  }

  .pos-font-fix .text-body-1 {
    font-size: 14px !important;
  }

  .pos-font-fix .text-body-2 {
    font-size: 13px !important;
  }

  .pos-font-fix .text-subtitle-1 {
    font-size: 14px !important;
  }

  .pos-font-fix .text-caption {
    font-size: 11px !important;
  }

  .pos-font-fix .v-icon {
    font-size: 20px !important;
  }

  .pos-font-fix {
    padding: 32px !important;
  }
  #QRCode {
    background-color: white !important;
  }
  @media print {
    @page {
      margin: 0;
    }
    body {
      margin: 0;
      -webkit-print-color-adjust: exact;
    }
    header,
    footer {
      display: none !important;
    }
  }
}
</style>
